import { render } from "./Overview.vue?vue&type=template&id=7a7ce0ba"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"
script.render = render

export default script